import { render } from "./BlogDetail.vue?vue&type=template&id=45098097"
import script from "./BlogDetail.vue?vue&type=script&lang=js"
export * from "./BlogDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__